"use client";

import { FlexColumn } from "@/components/Flex";
import LoadingAnimation from "@/components/LoadingAnimation";
import { themeColors } from "@/utils/themeColors";
import { useUserFollowingFollowers } from "@knowt/syncing/hooks/user/useUserFollowingFollowers";
import { spacing } from "@/utils/spacing";
import Image from "next/image";
import { useState } from "react";
import { UserProfileCardWithFollowHandler } from "../../../../components/userListCard/UserProfileCard";
import TabsAlternate from "@/components/Tabs/styled/TabsAlternate";

const TABS = [
    { label: "Followers", value: 0 },
    { label: "Following", value: 1 },
];

const FollowStatsCard = ({
    className,
    style,
    userId,
}: {
    className?: string;
    style?: React.CSSProperties;
    userId: string;
}) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const { following, followers, isValidating } = useUserFollowingFollowers({ userId });

    const listUser = selectedTab === 0 ? followers : following;
    const isFollowerTab = selectedTab === 1;

    const renderContent = () => {
        if (isValidating) {
            return <LoadingAnimation style={{ margin: "auto" }} />;
        }

        if (listUser.length === 0) {
            return (
                <FlexColumn style={{ alignItems: "center", gap: spacing.XS_2, textAlign: "center", margin: "auto" }}>
                    <Image src="/images/kai-sherlock-icon.svg" width={136} height={151} alt="No content found" />
                    <p className="bodyBold1" data-testid="auto-id-9c68261f-00c2-4aa6-bfca-b1164f593279">
                        {isFollowerTab ? "This user currently is not following anyone" : "They're not following anyone"}
                    </p>
                    <p className="body1" data-testid="auto-id-276abf54-3bdb-45ed-af36-55b81170c2aa">
                        Start following them and they <br data-testid="auto-id-06558ca9-f843-46b4-b89a-30bde010ca0e" />{" "}
                        might follow you back 😉
                    </p>
                </FlexColumn>
            );
        }

        return (
            <FlexColumn style={{ gap: "2.4rem" }}>
                {listUser.map((user, idx) => (
                    <UserProfileCardWithFollowHandler key={idx + user.userId} user={user} />
                ))}
            </FlexColumn>
        );
    };

    return (
        <FlexColumn
            className={className}
            style={{
                padding: "2rem",
                backgroundColor: themeColors.neutralWhite,
                borderRadius: "2rem",
                flex: 1,
                height: "fit-content",
                ...style,
            }}>
            <TabsAlternate
                tabs={TABS}
                containerStyle={{ margin: "0 auto 2rem" }}
                tabsSx={{ height: "4.8rem" }}
                tabSx={{ fontSize: "1.5rem" }}
                selectedTab={selectedTab}
                onChange={(_tab, i) => setSelectedTab(i)}
            />
            {renderContent()}
        </FlexColumn>
    );
};

export default FollowStatsCard;
